import { DocumentKind, StorageItem, StorageKind } from '../../constants/document';
import { getDocumentKindByContentType } from '../../utils';

const TreeViewItem = ({
  item,
}: any) => {
  const iconClassName = (item: StorageItem): string => {
    switch (getDocumentKindByContentType(item.contentType)) {
      case DocumentKind.image:
        return 'k-icon k-i-image';
      case DocumentKind.pdf:
        return 'k-icon k-i-file-pdf';
      case DocumentKind.office:
        return 'k-icon k-i-file-doc';
      default:
        return 'k-icon k-i-file';
    }
  };

  if (item.kind === StorageKind.document) {
    return (
      <span className="tree-item-label" data-path={item.path} title={item.text}>
        <span className={iconClassName(item)} key="0" />
        {item.text}
      </span>
    );
  } else {
    const folderIconClass = item.expanded ? 'k-i-folder-open' : 'k-i-folder';
    const total = item.documentCount ?? 0;
    const matched = item.matchedDocumentCount;
    const countLabel = matched !== undefined ? `${matched}/${total}` : `${total}`;
    return (
      <span
        className="tree-item-label"
        data-path={item.path}
        title={item.text}
        style={{ fontWeight: 'bold' }}
      >
        <span className={`k-icon ${folderIconClass}`} key="0" />
        {item.text} ({countLabel})
      </span>
    );
  }
};

export default TreeViewItem;
